<template>
  <nav class="flex flex-wrap items-center justify-between px-6 py-5 font-light bg-white shadow-lg">
    <div class="flex items-center mr-6 flex-no-shrink">
      <span @click="navigate('/')" class="text-xl font-semibold tracking-tight">Dealhopper</span>
    </div>
    <div class="block md:hidden">
      <button
        @click="toggle"
        class="flex items-center px-3 py-2 border rounded text-primary-orange border-gray-light hover:text-primary-orange hover:border-primary-orange"
      >
        <svg class="w-3 h-3 fill-current" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <title>Menu</title>
          <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
        </svg>
      </button>
    </div>
    <transition
      enter-active-class="transition-all duration-300 ease-in"
      leave-active-class="transition-all duration-200 ease-in"
      enter-class="opacity-0"
      leave-to-class="opacity-0"
    >
      <div
        :class="open ? 'block' : 'hidden'"
        class="flex-grow w-full lg:flex-grow-0 lg:w-auto md:flex md:items-center md:w-auto"
      >
        <div class="mr-6 text-primary-orange md:flex md:space-x-6 lg:space-x-10">
          <button
            v-if="$store.getters.isAdmin"
            text
            @click="navigate('/products')"
            class="block mt-4 lg:inline-block lg:mt-0"
          >
            Products
          </button>
          <button text @click="navigate('/')" class="block mt-4 lg:inline-block lg:mt-0">
            Drops
          </button>
          <button
            v-if="$store.getters.isAdmin"
            text
            @click="navigate('/areas')"
            class="block mt-4 lg:inline-block lg:mt-0"
          >
            Areas
          </button>
          <button
            v-if="$store.getters.isAdmin"
            text
            @click="navigate('/add')"
            class="block mt-4 lg:inline-block lg:mt-0"
          >
            Add Product
          </button>
          <button
            v-if="$store.getters.isAdmin"
            text
            @click="navigate('/admin')"
            class="block mt-4 lg:inline-block lg:mt-0"
          >
            Admin
          </button>
        </div>
      </div>
    </transition>
  </nav>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      open: false,
    };
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
    navigate(path) {
      this.$router.push(path);
      this.open = false;
    },
  },
};
</script>
